import React, { useState } from 'react';
import QuestionLabel from './QuestionLabel';
import mailcheck from 'mailcheck';
import { debounce } from '../../../lib/Utils.js';
import EmailInput from '../../EmailInput.jsx';
import { FormPart, part } from '~/lib/FormCssApi';

const EmailQuestion = ({ label, value, setValue, settings }) => {
    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            <div {...part(FormPart.CONTROL)}>
                <EmailInput
                    {...part(FormPart.INPUT)}
                    value={value}
                    onChange={setValue}
                />
            </div>
        </label>
    );
};

export default EmailQuestion;
